const ro = {
  tours: {
    pkg1: {
      price: "€790",
      title: "Evadare de weekend de lux în Europa/Maroc",
      duration: "3 nopți / 4 zile ",
      hl1: "Zboruri directe dus-întors incluse (Londra/Europa)",
      hl2: "Hoteluri de lux de 4-5 stele",
      hl3: "Hammam tradițional marocan",
      hl4: "Ateliere de gătit și artă",
      hl5: "Spectacole live marocane",
      hl1_brief: "Zboruri directe dus-întors incluse",
      subtitle: "Pachet all-inclusive – de la A la Z",
      flight1: "Zboruri directe dus-întors",
      flight2: "Bagaj de cală de 20 kg",
      flight3: "Bagaj de cabină de până la 8 kg",
      inc1: "Preluare de la aeroport și transfer înapoi",
      inc2: "Hoteluri de 4-5 stele (demipensiune)",
      inc3: "Bucătărie marocană proaspătă și autentică",
      inc4: "Experiență tradițională cu ceai și produse de patiserie",
      inc5: "Ghid turistic profesionist și șofer privat",
      inc6: "Transport modern cu aer condiționat",
      inc7: "Spectacole live speciale (cântăreți și dansatori)",
      inc7_brief: "Spectacole speciale live",
      inc8: "Tururi ale pieței tradiționale (condimente, lanternă, covor)",
      inc8_brief: "Tururi tradiționale ale pieței",
      inc9: "Ateliere de gătit și artă (este necesară rezervare prealabilă)",
      inc9_brief: "Ateliere de gătit și artă",
      inc10: "Vizite izvoare naturale și puncte de belvedere",
      inc11: "Excursii de o zi la Chefchaouen și Ifrane",
      inc12: "Vizite cu familiile marocane locale",
      inc13: "Experiențe surpriză în timpul turului",
      suit1: "Cupluri",
      suit2: "Familiile",
      suit3: "Grupuri",
      suit4: "Călători solitar",
      suit5: "Seniori",
      suit6: "Companii",
      suit7: "Agenții de turism",
      suit8: "Operatorii de turism"
    },
    pkg2: {
      price: "€1490",
      title: "Tur de descoperire a luxului Maroc",
      duration: "6 nopti / 7 zile ",
      hl1: "Pachetul A",
      hl2: "Mișcări Atlas",
      hl3: "Marakech - Essaouira - Merzouga - Ouarzazte - Marakech-",
      hl4: "Surpriză mare ❤️",
      hl5: "Pachetul B",
      subtitle: "Ruta Fes și Nordul Marocului (All Inclusive)",
      routeText: "2 nopți Fes, 1 noapte Chefchaouen, 1 noapte Tanger, 1 noapte Ifrane, 1 ultima noapte Fes",
      flight1: "Zboruri directe dus-întors din Europa",
      flight2: "Bagaj de 20 kg + Bagaj de cabină",
      trans1: "Preluare și transfer de la aeroport",
      trans2: "Sofer profesionist privat si ghid turistic",
      trans3: "Vehicule noi cu aer condiționat",
      hotel1: "hoteluri de 4-5 stele",
      hotel2: "Locații premium",
      hotel3: "Serviciu la nivel înalt",
      food1: "Demipensiune",
      food2: "Bucătărie autentică",
      food3: "Ceai și produse de patiserie tradiționale",
      exp1: "Spectacole live marocane",
      exp2: "Piețe tradiționale (condimente, felinar, covor)",
      exp2_brief: "Piețele tradiționale",
      exp3: "Hammam tradițional marocan",
      exp4: "Vizite în natură și pădure",
      exp4_brief: "Vizite în natură",
      exp5: "Puncte de belvedere frumoase și excursii de o zi",
      exp6: "Ateliere de gătit și artă",
      exp7: "Vizite cu familiile locale",
      exp8: "Surprize speciale în timpul călătoriei",
      suit1: "Cupluri",
      suit2: "Familiile",
      suit3: "Grupuri",
      suit4: "Călători solitar",
      suit5: "Seniori",
      suit6: "Companii",
      suit7: "Agenții de turism"
    },
    pkg3: {
      price: "€1990",
      title: "Marea experiență a Marocului",
      duration: "10 nopți / 11 zile ",
      hl1: "Servicii complete premium la sol",
      hl2: "Casablanca, Marrakech și Fes",
      hl3: "Surprize în desertul Agadir și Sahara",
      hl4: "Vizitați Ouarzazate și Chefchaouen",
      hl5: "Muzică live și spectacole speciale",
      subtitle: "✨ Maroc Grand Experience (numai servicii la sol)",
      arrivalText: "Casablanca sau Marrakech",
      routeText: "Casablanca, Rabat, 2 nopti Fes, Tanger, Chefchaouen, Ifrane, 2 nopti Marrakech, Agadir, Ouarzazate, ultima noapte Marrakech",
      note2: "Grupuri > 40: Reducere specială de 50 USD de persoană",
      note3: "Zboruri internaționale și asigurare NU sunt incluse",
      note4: "Sfaturi pentru șofer/ghid NU sunt incluse",
      inc1: "Servicii complete premium la sol",
      inc2: "Hoteluri de 4-5 stele (demipensiune)",
      inc3: "Ghid turistic profesionist și șofer privat",
      inc4: "Autobuz sau microbuz cu aer condiționat",
      inc5: "Spectacole live și atmosferă muzicală",
      inc6: "Piețe tradiționale și vizite la hamam",
      inc7: "Ateliere de gătit și artă",
      inc8: "Excursii la păduri, izvoare și puncte de belvedere",
      inc9: "Vizite cu familiile locale",
      inc10: "Surprize speciale în timpul călătoriei"
    },
    pageTitle: "Tururi și pachete",
    pageSubtitle: "Alegeți dintre pachetele noastre de turism în Maroc, îngrijite cu grijă",
    sectionTitle: "Pachetele noastre turistice",
    sectionIntro: "De la aventuri în deșert la evadări pe coastă, avem pachetul perfect pentru fiecare călător",
    howToBook: "Cum să rezervați",
    step1Title: "Alegeți un tur",
    step1Text: "Răsfoiți pachetele noastre și selectați-l pe cel care vi se potrivește cel mai bine",
    step2Title: "Faceți clic pe Rezervați acum",
    step2Text: "Faceți clic pe butonul „Rezervați acum” din turul ales",
    step3Title: "Completați detaliile",
    step3Text: "Furnizați datele de călătorie și informațiile personale",
    step4Title: "Confirmare",
    step4Text: "Primiți confirmarea și detaliile itinerarului prin e-mail",
    customTitle: "Aveți nevoie de un pachet personalizat?",
    customText: "Contactați-ne pentru a crea o experiență personalizată de tur în Maroc",
    customBtn: "Luați legătura",
    days: "Zile",
    highlights: "Repere:",
    bookNow: "Rezervați acum",
    highlightsLabel: "RELEVATE:",
    viewFullDetails: "Vezi detalii complete",
    viewDetails: "Vedeți detalii",
    premiumPackage: "Pachet Premium",
    arrival: "Sosire:",
    route: "Traseu:",
    flights: "Zboruri:",
    transportation: "transport:",
    hotels: "Hoteluri:",
    foodDining: "Mâncare și mese:",
    whatsIncluded: "Ce este inclus:",
    attractionsExperiences: "Atracții și experiențe:",
    itinerary: "Itinerar:",
    optionalExperiences: "Experiențe opționale:",
    availableUponRequest: "Disponibil la cerere:",
    specialSaharaExperience: "Experiență specială în Sahara:",
    suitableFor: "Potrivit pentru:",
    importantNotes: "Note importante:",
    priceInformation: "Informații despre preț:",
    priceWarningText: "Prețurile se pot modifica în funcție de prețurile zborurilor, cursurile de schimb, sărbători, anotimpuri și disponibilitatea hotelului.",
    safetyComfort: "Siguranță și confort:",
    safetyText: "Lucrăm în coordonare cu autoritățile și serviciile de securitate marocane pentru a asigura siguranța și confortul oaspeților noștri.",
    safetyTextBrief: "Coordonat cu autoritățile marocane pentru siguranța dumneavoastră.",
    givesMore: "Marocul te iubește oferă mai mult:",
    givesMoreText: "Mai multă dragoste, grijă, profesionalism, bucurie și siguranță. Tururi ușoare și relaxante cu adevărată ospitalitate umană.",
    givesMoreBrief: "Marocul te iubește:",
    givesMoreTextBrief: "Mai multă dragoste, grijă și profesionalism.",
    bookThisPackage: "Rezervați acest pachet",
    backToPackages: "Înapoi la Pachete",
    premiumMoroccoPackages: "Pachete Premium Maroc",
    premiumMoroccoPackagesDesc: "Experiențe exclusive, atent organizate pentru oaspeții noștri pretențioși.",
    suitable: {
      couples: "Cupluri",
      families: "Familiile",
      groups: "Grupuri",
      solo: "Călători solitar",
      seniors: "Seniori",
      companies: "Companii",
      agencies: "Agenții de turism",
      operators: "Operatorii de turism"
    },
    pkg4: {
      title: "EXPERIENȚĂ DE LUX MAROC",
      duration: "16 nopți / 17 zile",
      price: "All Inclusive",
      hl1: "Casablanca • Rabat • Fez • Tanger • Chefchaouen",
      hl2: "Ifrane • Deșertul Sahara Merzouga",
      hl3: "Essaouira • Munții Ourika și Atlas • Marrakech",
      hl3_brief: "Vizitați Munții Atlas",
      hl4: "Tabără de lux în deșert de 2 nopți cu excursii cu cămilă și jeep",
      hl5: "Răsărit și apus magic • Dormi sub stele",
      subtitle: "✨ Maroc Imperial & Sahara Experience - Călătoria completă (16 nopți / 17 zile)",
      routeText: "Casablanca (1 noapte), Rabat, Fez (2 nopți), Tanger (1 noapte), Chefchaouen (1 noapte), Ifrane (1 noapte), Merzouga Sahara (2 nopți), Essaouira (2 nopți), Ourika și Munții Atlas (1 noapte), Marrakech (3 nopți)",
      inc1: "4★ / 5★ Hoteluri",
      inc2: "Tabără de lux cu aer condiționat în deșert",
      inc2_brief: "hoteluri de 4-5 stele",
      inc3: "Pensiune completă / Bucătărie marocană premium",
      inc3_brief: "Ghid turistic profesionist",
      inc4: "Ghiduri multilingve profesionale",
      inc4_brief: "Spectacole speciale live",
      inc5: "Transport privat modern",
      inc5_brief: "Piețele tradiționale",
      inc6: "Autocare cu aer condiționat",
      inc7: "WiFi • TV • Frigider la bord",
      inc8: "Șofer privat pe tot parcursul turului",
      inc9: "Tururi cu cămile",
      inc10: "Experiență Jeep Desert",
      inc11: "Spectacole de folclor și muzică live",
      inc12: "Spectacole de dans marocan",
      inc13: "Ateliere de gătit",
      inc14: "Experiențe piețe și souks",
      inc15: "Covoare • Condimente • Flori • Meșteșuguri tradiționale",
      inc16: "Lacuri • Râuri • Munții Atlas",
      inc17: "Experiențe speciale la răsărit și apus",
      inc18: "Asistență directă 24/7",
      optional1: "Experiență cu balonul cu aer cald",
      optional2: "Upgrade VIP",
      optional3: "Experiențe de lux",
      optional4: "Servicii de securitate privată",
      optional5: "Servicii de asistență medicală",
      optionalNote: "Unele servicii premium pot necesita un supliment suplimentar echitabil.",
      sahara1: "Corturi de deșert premium cu aer condiționat",
      sahara2: "Atmosfera muzicala de foc de tabara",
      sahara3_brief: "Excursii cu jeep și plimbări cu cămile",
      itinerary1: "Casablanca - Sosire (1 noapte)",
      itinerary2: "Rabat - Capitala Regală",
      itinerary3: "Fez - Maroc spiritual și cultural (2 nopți)",
      itinerary4: "Tanger - Unde Europa întâlnește Africa (1 noapte)",
      itinerary5: "Chefchaouen - Perla albastră (1 noapte)",
      itinerary6: "Ifrane - Elveția marocană (1 noapte)",
      itinerary7: "Deșertul Sahara Merzouga (2 nopți) - Tabără de lux în deșert - Experiență cu cămile - Tururi cu jeep - Răsărit și apus magic - Dormit sub stele",
      itinerary8: "Essaouira - Evadare în Oceanul Atlantic (2 nopți)",
      itinerary9: "Ourika și Munții Atlas (1 noapte)",
      itinerary10: "Marrakech - Orașul Roșu (3 nopți)"
    }
  },
  tourMini: {
    years: "2026 - 2027",
    days: "10 ZILE",
    nights: "/ 9 NOPTI",
    title: "MAROC PREMIUM\nTUR",
    departures: "PLECĂRI LUNARĂ",
    allIncluded: "TOTUL INCLUS\nPENSIUNE COMPLETA",
    recommendations: "Recomandări",
    recCount: "Peste 500 de călători fericiți"
  },
  testimonials_data: {
    testi1: {
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
      name: "Sarah Johnson",
      title: "Londra, Marea Britanie",
      text: "Maroc te iubește a făcut din călătoria mea visată realitate! Fiecare detaliu a fost organizat perfect, de la hoteluri de lux până la experiențe autentice. Serviciul este de neegalat. Deja îmi plănuiesc vizita de întoarcere!",
      rating: 5
    },
    testi2: {
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d",
      name: "Michael Chen",
      title: "Singapore",
      text: "Ca călător de afaceri, am fost impresionat de profesionalism și personalizare. Tratament VIP din prima zi, itinerar personalizat și logistică impecabilă. Foarte recomandat pentru călătorii executive.",
      rating: 5
    },
    testi3: {
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80",
      name: "Emma Wilson",
      title: "Sydney, Australia",
      text: "Experiența în deșert a fost magică! Dormit sub stele, drumeții cu cămile și căldura ospitalității marocane au depășit toate așteptările. Vă mulțumim că ne-ați creat amintiri de-a lungul vieții!",
      rating: 5
    },
    testi4: {
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
      name: "James Rodriguez",
      title: "Madrid, Spania",
      text: "Planificarea călătoriei în familie poate fi stresantă, dar Morocco Loves You a gestionat totul cu brio. Sigur, educațional și distractiv pentru toate vârstele. Copiii noștri încă mai vorbesc despre vizitele la medină!",
      rating: 5
    },
    testi5: {
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d",
      name: "Anna Mueller",
      title: "Berlin, Germania",
      text: "Am apreciat autenticitatea culturală și respectul față de tradițiile locale. Acesta nu a fost doar turism; a fost o adevărată imersiune culturală. Bravo întregii echipe!",
      rating: 5
    },
    testi6: {
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
      name: "David Thompson",
      title: "Toronto, Canada",
      text: "Accesibilitatea pentru seniori a fost excepțională. Ritmul confortabil, ghidurile de sprijin și cazarea de lux i-au făcut pe bunicii mei incredibil de fericiți. Un serviciu căruia îi pasă cu adevărat.",
      rating: 5
    },
    testi7: {
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80",
      name: "Lisa Anderson",
      title: "New York, SUA",
      text: "Iubitor de mâncare aici! Experiențele culinare au fost rafinate. Fiecare masă a spus o poveste, fiecare ghid a arătat o pasiune autentică. Aromele Marocului vor rămâne cu mine pentru totdeauna.",
      rating: 5
    },
    testi8: {
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d",
      name: "Marcus Smith",
      title: "Los Angeles, SUA",
      text: "Plin de aventuri, dar luxos – exact ceea ce căutam. Trekking Atlas, safari în deșert, toate cu confort VIP. Merita fiecare banut!",
      rating: 5
    },
    testi9: {
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
      name: "Sophie Laurent",
      title: "Paris, Franța",
      text: "Excursie romantică extraordinară! Apus de soare în Sahara, cine private cu vedere la Marrakech și servicii atente pe tot parcursul. Maroc te iubește cu adevărat se ridică la înălțimea numelui lor.",
      rating: 5
    },
    intro: "Faceți cunoștință cu oaspeții noștri mulțumiți care au experimentat Marocul prin serviciile noastre"
  },
  stats: {
    happyTravelers: "5000+",
    yearsExperience: "15+",
    destinationsCount: "25+",
    satisfactionRate: "98%"
  },
  nav: {
    home: "Acasă",
    about: "Despre noi",
    destinations: "Destinații",
    tours: "Tururi și pachete",
    gallery: "Galerie",
    testimonials: "Mărturii",
    blog: "Blog",
    contact: "Contactați-ne",
    experiences: "Experiențe",
    vip: "Afaceri VIP",
    vipFull: "Călătorii de afaceri VIP",
    worldcup: "Cupa Mondială 2030",
    careers: "Cariere",
    chatWhatsApp: "Chat pe WhatsApp",
    jewishHeritage: "Călătorii cușer",
    menu: "Meniu"
  },
  hero: {
    welcome: "Bun venit în Maroc.",
    welcomeHome: "Bun venit Acasă.",
    subtitle: "Tururi private de lux, experiențe autentice,",
    subtitleLine2: "și servicii complete personale în Maroc -",
    subtitleGold: "gestionat personal de CEO.",
    whatsappBtn: "Chat cu Ilan (CEO) acum pe WhatsApp",
    badgeFast: "Răspuns rapid",
    badgePersonal: "Serviciu personal",
    badge247: "Disponibilitate 24/7",
    limitedAvail: "Disponibilitate limitată",
    personalizedOnly: "Numai excursii personalizate"
  },
  strip: {
    privateTours: "Tururi private",
    localExperts: "Experți locali",
    bestHotels: "Cele mai bune hoteluri",
    luxuryTransport: "Transport de lux",
    satisfaction: "100% Satisfacție"
  },
  cta: {
    whatsapp: "Chat cu Ilan (CEO) acum pe WhatsApp",
    whatsappFloating: "Chat pe WhatsApp",
    whatsappInquiry: "Bună ziua, sunt interesat de o experiență premium de călătorie în Maroc."
  },
  home: {
    vipBannerTitle: "Experiențe de călătorie VIP Maroc",
    vipBannerText: "Acces exclusiv, șoferi privați și cazare de lux, adaptate pentru călătorii exigenți.",
    vipBannerBtn: "Descoperiți Servicii VIP",
    wcBadge: "🇲🇦 Cupa Mondială Maroc 2030",
    wcTitle: "Maroc 2030",
    wcText: "Pachete de călătorie exclusive la Cupa Mondială care combină fotbal, cultura marocană, ospitalitate VIP și experiențe de lux.",
    wcBtn: "Vezi pachete",
    galleryTitle: "Galerie",
    gallerySubtitle: "O privire asupra viitoarei călătorii marocane",
    exploreDestination: "Explorați destinația",
    featuredToursTitle: "Tururi și pachete recomandate",
    featuredToursSubtitle: "Experiențe îngrijite cu grijă pentru aventura marocană perfectă",
    viewAllTours: "Vezi toate tururile",
    culinaryTitle: "Mâncarea noastră - cea mai bună din lume",
    culinarySubtitle: "Experimentați excelența culinară marocană 🍲",
    culinaryBtn: "Descoperiți experiențe culinare",
    culinaryIntro: "La Morocco Loves You, masa nu înseamnă doar mâncare. Este o călătorie în inima culturii marocane. Oferim experiențe culinare autentice, alese manual - de la mâncăruri tradiționale gătite în casă până la gastronomie marocană de lux, toate pregătite cu dragoste și cele mai proaspete ingrediente locale.",
    culinaryVideoTitle: "Videoclipuri cu experiență culinară",
    culinaryFeatures: [
      "Tagine tradiționale",
      "Cuscus autentic",
      "Produse de patiserie marocane",
      "Ceremoniile ceaiului",
      "Cursuri de gătit",
      "Condimente locale",
      "Ingrediente organice",
      "Mâncăruri gătite în casă"
    ],
    videoTitle: "RECOMANDĂRI",
    unityQuote: "Marocul te iubește salută toate culturile, toate credințele și toate popoarele.",
    unityAlt: "Bannerul Maroc te iubește pentru unitate",
    testimonialsTitle: "Ce spun oaspeții noștri VIP",
    testimonialsSubtitle: "Recenzii reale de la călători internaționali",
    readMoreReviews: "Citiți mai multe recenzii",
    viewAllTransport: "Vezi toate transporturile",
    transportTitle: "Transportul și șoferii noștri VIP",
    transportSubtitle: "Lux, confort și siguranță în Maroc 🌍",
    transportIntro: "La Morocco Loves You, transportul nu înseamnă doar mutarea dintr-un loc în altul. Face parte din experiență. Oferim vehicule moderne, curate, confortabile și complet cu aer condiționat în Maroc - cu șoferi profesioniști, ospitalitate caldă și servicii VIP din primul moment."
  },
  destinations: {
    pageTitle: "Explorați destinațiile Marocului",
    pageSubtitle: "Descoperiți locuri incredibile de vizitat în frumosul Maroc",
    sectionTitle: "Toate Destinațiile",
    sectionIntro: "Marocul este o țară cu peisaje diverse și cu un bogat patrimoniu cultural. Explorați destinațiile noastre atent selectate:",
    exploreNow: "Explorează acum",
    ctaTitle: "Sunteți gata să vă planificați călătoria?",
    ctaText: "Răsfoiți tururile și pachetele noastre organizate pentru a găsi experiența marocană perfectă",
    ctaBtn: "Vezi tururi și pachete"
  },
  experiences: {
    pageTitle: "Excelența culinară marocană",
    pageSubtitle: "Descoperiți mâncarea noastră - cea mai bună din lume",
    bookViaWhatsApp: "Rezervați prin WhatsApp",
    introTitle: "Experiența noastră culinară marocană unică",
    introHighlight: "Arome autentice, ingrediente proaspete, secole de tradiție și ospitalitate de neuitat.",
    introP1: "Bine ați venit la aromele autentice ale Marocului.",
    introP2: "La Morocco Loves You, mâncarea nu este doar o masă, ci este cultură, istorie, familie, ospitalitate și dragoste.",
    introP3: "Timp de secole, bucătăria marocană a fost considerată una dintre cele mai bogate, mai sănătoase și mai aromate bucătării din lume.",
    introP4: "Tradițiile noastre culinare combină influențele arabe, berbere, evreiești marocane, andaluze, mediteraneene și africane - creând rețete unice păstrate de mai bine de 500 de ani.",
    prepTitle: "Arta pregătirii marocane",
    prepP1: "Totul este pregătit cu grijă, pasiune, ingrediente locale proaspete și condimente marocane autentice.",
    prepP2: "Selectăm cu atenție restaurante de încredere, experiențe locale autentice și destinații culinare de calitate pentru oaspeții noștri.",
    prepP3: "Marocul este cunoscut în întreaga lume pentru piețele sale colorate, agricultura proaspătă, produsele naturale, mirodeniile, măslinele, portocalele, produsele de patiserie, ceaiul de mentă și ospitalitatea de neuitat.",
    journeyVideos: "Videoclipuri cu călătorie culinară",
    highlightsTitle: "Repere culinare tradiționale",
    highlightTagine: "Tagine marocană autentică",
    highlightCouscous: "Cușcuș tradițional",
    highlightVegetables: "Legume proaspete și ingrediente naturale",
    highlightPastries: "Produse de patiserie și deserturi de casă",
    highlightBreakfasts: "Mic dejun tradițional marocan",
    highlightMeat: "Pește proaspăt și carne de calitate",
    highlightJuices: "Sucuri naturale și ceai marocan",
    highlightHealthy: "Tradiții culinare sănătoase și delicioase",
    galleryTitle: "Galeria noastră culinară",
    summaryP1: "Scopul nostru este să oferim oaspeților noștri nu doar o călătorie, ci și o adevărată călătorie culinară marocană.",
    tagHealthy: "Sănătos",
    tagAuthentic: "Autentic",
    tagTraditional: "Tradițional",
    tagFresh: "proaspăt",
    tagUnique: "Unic",
    tagDelicious: "delicios",
    important: "Important:",
    guidanceNote: "Pentru cea mai bună experiență culinară, vă recomandăm insistent să urmați îndrumările echipei noastre și recomandările culinare în timpul călătoriei dumneavoastră în Maroc.",
    whereMeal: "Unde fiecare masă devine o amintire.",
    whatsappLabel: "WhatsApp: +972 54-633-8757",
    moroccoLine: "Linia Maroc: +212 6 63 63 05 79"
  },
  vip: {
    pageTitle: "VIP și călătorii de afaceri",
    pageSubtitle: "Servicii exclusive pentru directori generali, investitori și călători cu discernământ",
    introTitle: "Excelență fără întreruperi în Maroc",
    introText: "MoroccoLovesYou oferă un standard de servicii fără egal pentru călătorii de afaceri, delegațiile corporative și oaspeții VIP. Înțelegem că timpul tău este valoros și standardele tale sunt fără compromisuri. De la aterizare până la plecare, gestionăm fiecare detaliu cu precizie, permițându-vă să vă concentrați asupra obiectivelor dvs. de afaceri, în timp ce oferim o experiență marocană fără cusur.",
    ctaTitle: "Acces direct la CEO",
    ctaText: "Pentru întrebări urgente și solicitări foarte specializate, discutați direct cu fondatorul și CEO-ul nostru, Ilan Hatchuel.",
    ctaBtn: "Contactați acum Ilan",
    luxuryTransport: "Transport de lux",
    luxuryTransportDesc: "Transferuri VIP la aeroport și șoferi bilingvi personali disponibili 24/7 cu vehicule de lux (Mercedes S-Class, V-Class).",
    premiumAccom: "Cazare Premium",
    premiumAccomDesc: "Rezervări exclusive la hoteluri de 5 stele, riaduri de lux sau vile private potrivite pentru directori și echipele acestora.",
    businessConcierge: "Concierge de afaceri",
    businessConciergeDesc: "Asistență completă pentru întâlniri, rezervări private pentru mese și itinerarii specializate pentru retrageri corporative.",
    securityPrivacy: "Securitate și confidențialitate",
    securityPrivacyDesc: "Servicii discrete, medii sigure și confidențialitate absolută pentru persoane și celebrități de profil.",
    support247: "Asistență 24/7",
    support247Desc: "Contact direct cu CEO-ul și o echipă dedicată gata să vă asiste în orice moment în timpul șederii dumneavoastră.",
    customItineraries: "Itinerarii personalizate",
    customItinerariesDesc: "Planuri de călătorie personalizate care echilibrează perfect obligațiile dvs. de afaceri cu experiențe culturale premium marocane."
  },
  worldcup: {
    pageTitle: "Cupa Mondială Maroc 2030",
    pageSubtitle: "Pachete VIP exclusive și experiențe de călătorie pentru cel mai mare eveniment de fotbal",
    limitedBadge: "Disponibilitate limitată",
    introTitle: "Ultima călătorie la fotbal",
    introText: "În 2030, Marocul va găzdui împreună Cupa Mondială FIFA, aducând cel mai prestigios eveniment sportiv din lume în Africa de Nord. MoroccoLovesYou este mândru să ofere pachete de călătorie de lux exclusive, all-inclusive, concepute pentru fanii care solicită cel mai bun confort, acces și experiență.",
    packagesTitle: "Pachete premium pentru Cupa Mondială",
    silverTitle: "Pachet Argint",
    silverSub: "Experiența esențială",
    goldTitle: "Pachet Aur",
    goldSub: "Experiența de lux",
    mostPopular: "Cele mai populare",
    diamondTitle: "Diamond VIP",
    diamondSub: "Experiența supremă",
    inquireWhatsApp: "Întrebați prin WhatsApp",
    ctaTitle: "Asigurați-vă locul înainte de creșterea prețurilor",
    ctaText: "Datorită cererii internaționale extrem de ridicate, vă recomandăm să vă asigurați pachetul VIP din timp. Cazările din orașele gazdă se vor epuiza.",
    ctaBtn: "Contactați-ne astăzi",
    silverF1: "Riad Premium / Cazare hotel de 4 stele",
    silverF2: "Logistica pre-planificată în ziua meciului",
    silverF3: "Tururi de oraș cu ghid (orașe gazdă)",
    silverF4: "Linie de asistență dedicată 24/7",
    goldF1: "Hotel de 5 stele / Cazare vilă de lux",
    goldF2: "Transferuri private la aeroport și meciuri",
    goldF3: "VIP Desert Camp Getaway (2 zile)",
    goldF4: "Concierge personal bilingv",
    diamondF1: "Suite prezidențiale / Palate private",
    diamondF2: "Șofer privat și securitate 24/7",
    diamondF3: "Acces exclusiv la evenimente și petreceri VIP",
    diamondF4: "Direct CEO Handling & VVIP Concierge"
  },
  gallery: {
    pageTitle: "Galeria noastră",
    pageSubtitle: "Amintiri vizuale ale călătoriilor marocane de neuitat",
    picturesTitle: "Maroc în imagini",
    picturesIntro: "Explorați colecția noastră de fotografii uluitoare din Maroc",
    videosTitle: "Marocul în mișcare",
    videosIntro: "Experimentați Marocul prin colecția noastră de videoclipuri",
    catFood: "Experiență culinară",
    catDestinations: "Destinații",
    catKosher: "Kosher",
    catTransport: "Transport VIP"
  },
  testimonials: {
    pageTitle: "Mărturii invitate",
    pageSubtitle: "Citiți ce au de spus călătorii noștri despre experiența lor marocană",
    sectionTitle: "Călătorii noștri fericiți",
    sectionIntro: "Mii de oaspeți mulțumiți au experimentat cu noi magia Marocului",
    verifiedGuest: "Invitat verificat",
    ratingsTitle: "Evaluările noastre",
    avgRating: "Evaluare medie",
    verifiedReviews: "Recenzii verificate",
    fromReal: "De la călători adevărați",
    custSatisfaction: "Satisfacția clientului",
    wouldRecommend: "Aș recomanda",
    shareTitle: "Împărtășiți-vă experiența",
    shareText: "Ai avut o excursie minunată cu noi? Ne-ar plăcea să auzim despre asta!",
    shareBtn: "Spune-ne povestea ta"
  },
  blog: {
    pageTitle: "Blog de călătorie",
    pageSubtitle: "Povești, sfaturi și ghiduri pentru aventura ta marocană",
    sectionTitle: "Ultimele articole de călătorie",
    sectionIntro: "Citiți cele mai recente articole ale noastre despre călătoriile în Maroc, cultura locală și sfaturi din interior",
    readMore: "Citește mai mult →",
    by: "De către",
    newsletterTitle: "Abonați-vă la Newsletter-ul nostru",
    newsletterText: "Primiți cele mai recente sfaturi de călătorie și oferte exclusive livrate în căsuța dvs. de e-mail",
    newsletterPlaceholder: "Introduceți adresa dvs. de e-mail",
    subscribe: "Abonați-vă"
  },
  contact: {
    pageTitle: "Contactați-ne 24/7",
    pageSubtitle: "Luați legătura cu echipa noastră pentru a vă planifica aventura VIP în Maroc",
    getInTouch: "Contactați-ne",
    getInTouchText: "Suntem aici pentru a vă ajuta și pentru a răspunde la orice întrebări ați putea avea. Echipa noastră este pregătită să vă ajute în planificarea călătoriei perfecte în Maroc.",
    address: "Adresa noastră",
    addressText: "53 Mohammed V Street, Fes, Maroc",
    phone: "Numere de telefon 📞",
    directPhone: "Telefon direct: +212 6 63 63 05 79",
    whatsappPhone: "WhatsApp: +972 54 633 8757",
    email: "Adrese de e-mail profesionale",
    emailList: [
      "CEO@MoroccoLovesYou.com",
      "Info@MoroccoLovesYou.com",
      "Vânzări@MoroccoLovesYou.com",
      "Michael@MoroccoLovesYou.com",
      "Kim@MoroccoLovesYou.com"
    ],
    businessHours: "Programul de lucru",
    businessHoursText: "Disponibil 24/7\n7 zile pe săptămână",
    responseTime: "Vă vom contacta în termen de 48 de ore.",
    welcomeMessage: "Bine ați venit în Maroc 🇲🇦",
    followUs: "Urmărește-ne",
    formTitle: "Trimite-ne un Mesaj",
    successMessage: "✓ Mulțumesc! Vă vom reveni în curând.",
    firstName: "Prenume",
    lastName: "Nume de familie",
    emailAddress: "Adresa de email",
    phoneNumber: "Număr de telefon",
    subject: "Subiect",
    selectSubject: "Selectați un subiect",
    tourInquiry: "Întrebare de tur",
    bookingQuestion: "Întrebare de rezervare",
    customPackage: "Pachet personalizat",
    feedback: "Feedback",
    other: "Altele",
    message: "Detalii / Mesaj",
    sendMessage: "Trimite mesaj",
    mapTitle: "Găsiți-ne pe Hartă",
    faqTitle: "Întrebări frecvente",
    faq1Q: "Care este cel mai bun moment pentru a vizita Marocul?",
    faq1A: "Primăvara (aprilie-mai) și toamna (septembrie-octombrie) oferă cea mai bună vreme. Vara este caldă în deșert, iar iarna este blândă, dar poate fi ploioasă.",
    faq2Q: "Am nevoie de viză pentru a vizita Maroc?",
    faq2A: "Cerințele pentru viză depind de naționalitatea dumneavoastră. Multe ț��ri au intrare fără viză pentru până la 90 de zile. Verificați cu ambasada locală.",
    faq3Q: "Ce monedă este folosită în Maroc?",
    faq3A: "Dirhamul marocan (MAD) este moneda oficială. ATM-urile sunt disponibile pe scară largă în orașe, iar majoritatea locurilor acceptă carduri de credit.",
    faq4Q: "Ce limbă se vorbește în Maroc?",
    faq4A: "Araba și berbera (amazigh) sunt limbi oficiale. Franceza este vorbită pe scară largă, iar engleza este din ce în ce mai frecventă în zonele turistice.",
    faq5Q: "Este Marocul sigur pentru turiști?",
    faq5A: "Da, Marocul este în general sigur pentru turiști. Se aplică precauții de bun simț. Ghizii noștri vă asigură că aveți o experiență sigură și plăcută.",
    faq6Q: "Îmi pot personaliza pachetul turistic?",
    faq6A: "Absolut! Oferim pachete personalizate adaptate intereselor, bugetului și datelor dvs. de călătorie. Contactați-ne pentru a discuta cerințele dvs."
  },
  about: {
    pageTitle: "Despre MoroccoLovesYou",
    pageSubtitle: "Partenerul tău de încredere în descoperirea magiei Marocului",
    storyTitle: "Povestea noastră",
    storyP1: "MoroccoLovesYou a fost fondat cu o misiune simplă: să ajute călătorii să experimenteze frumusețea, cultura și ospitalitatea autentică a Marocului. Ceea ce a început ca un mic serviciu de ghid de călătorie s-a transformat într-o companie de turism cuprinzătoare care deservește mii de vizitatori anual.",
    storyP2: "Fondatorul nostru, Fatima Hassan, s-a îndrăgostit de Maroc și a vrut să împărtășească această pasiune lumii. Astăzi, ne mândrim să creăm experiențe personalizate, autentice, care depășesc turismul tipic.",
    missionTitle: "🎯 Misiunea noastră",
    missionText: "Pentru a oferi experiențe de călătorie excepționale care să prezinte bogata moștenire culturală a Marocului, peisajele uimitoare și ospitalitatea caldă, sprijinind în același timp comunitățile locale și practicile turistice durabile.",
    visionTitle: "🌟 Viziunea noastră",
    visionText: "A fi cea mai importantă companie de turism din Maroc, cunoscută pentru autenticitate, fiabilitate și crearea de amintiri de neuitat pentru fiecare călător care alege să exploreze această țară magnifică cu noi.",
    whyTitle: "De ce să alegeți MoroccoLovesYou?",
    expertTitle: "Cunoștințe de specialitate",
    expertText: "Echipa noastră are cunoștințe extinse despre Maroc și oferă recomandări personalizate.",
    localTitle: "Conexiuni locale",
    localText: "Lucrăm cu ghizi locali autentici și familii pentru a asigura experiențe autentice.",
    valueTitle: "Cea mai bună valoare",
    valueText: "Prețuri competitive fără a compromite calitatea și experiența.",
    safetyTitle: "Siguranță și asistență",
    safetyText: "Asistență clienți 24/7 și asigurare completă de călătorie incluse.",
    sustainTitle: "Turism durabil",
    sustainText: "Sprijinim comunitățile locale și practicăm turismul responsabil.",
    bookingTitle: "Rezervare ușoară",
    bookingText: "Proces simplu de rezervare online, cu opțiuni de plată flexibile.",
    teamTitle: "Echipa noastră",
    teamSubtitle: "Faceți cunoștință cu oamenii pasionați din spatele MoroccoLovesYou",
    happyTravelers: "Călători Fericiți",
    yearsExp: "Ani de experiență",
    destinationsCount: "Destinații",
    satisfactionRate: "Rata de satisfacție"
  },
  footer: {
    description: "Descoperiți magia Marocului împreună cu noi. Trăiește aventuri de neuitat și creează amintiri de durată.",
    quickLinks: "Legături rapide",
    more: "Mai mult",
    contactInfo: "Informații de contact",
    copyright: "© 2024 MoroccoLovesYou. Toate drepturile rezervate."
  },
  starBanner: {
    ceoMessage: "MESAJUL CEO",
    watchVideo: "Urmăriți videoclipul meu",
    readMessage: "și citește-mi mesajul",
    getToKnow: "Fă cunoștință",
    ilanPersonally: "Ilan personal"
  },
  cityDetail: {
    notFound: "Orașul nu a fost găsit",
    backHome: "Înapoi la Acasă",
    discoverSubtitle: "Descoperiți frumusețea și cultura",
    planTrip: "Planifică-mi călătoria către",
    galleryOf: "Galeria de",
    bookExperience: "Rezervați această experiență",
    requestItinerary: "Solicitați itinerarul complet",
    readyToVisit: "Gata de vizitat",
    readyToVisitText: "Lasă-ne să planificăm călătoria ta perfectă către această destinație uimitoare",
    planMyTrip: "Planificați-mi călătoria",
    talkExpert: "Discutați cu un expert"
  },
  transportation: {
    pageTitle: "Transport VIP și șoferi",
    pageSubtitle: "Lux, confort și siguranță în Maroc",
    introTitle: "Transportul și șoferii noștri VIP",
    introP1: "La Morocco Loves You, transportul nu înseamnă doar mutarea dintr-un loc în altul.",
    introP2: "Face parte din experiență.",
    introP3: "Oferim vehicule moderne, curate, confortabile și complet cu aer condiționat în Maroc - cu șoferi profesioniști, ospitalitate caldă și servicii VIP din primul moment.",
    introP4: "Indiferent dacă călătoriți în cuplu, în familie, în delegație de afaceri sau în grup privat, ne asigurăm că călătoria dvs. este sigură, relaxantă și de neuitat.",
    servicesTitle: "Serviciile noastre de transport includ",
    servicesList: [
      "Autobuze VIP moderne",
      "Microbuze de lux",
      "Mașini private",
      "Jeep-uri 4x4 pentru aventuri în deșert",
      "limuzine VIP",
      "Preluare și predare de la aeroport",
      "Șoferi profesioniști multilingvi",
      "Aer condiționat confortabil",
      "Vehicule curate si organizate",
      "Frigidere în vehicule selectate",
      "TV și sisteme de divertisment",
      "Muzica in timpul calatoriei",
      "Conducere sigură și lină",
      "Asistență 24/7 în Maroc"
    ],
    featureList: [
      "Autobuze VIP moderne",
      "Microbuze de lux",
      "Mașini private",
      "Jeep-uri 4x4",
      "Preluare de la aeroport",
      "Șoferi multilingvi",
      "Asistență 24/7",
      "Conducere în siguranță"
    ],
    driversTitle: "Faceți cunoștință cu șoferii noștri",
    driversText1: "Șoferii noștri fac parte din familia Morocco Loves You.",
    driversText2: "Profesionist, respectuos, experimentat și mereu gata să ajute cu un zâmbet.",
    driversText3: "Mulți dintre șoferii noștri vorbesc mai multe limbi și cunosc Marocul profund, ajutându-i pe oaspeții noștri să se simtă confortabil, în siguranță și conectați pe tot parcursul călătoriei.",
    safetyTitle: "Siguranța și confortul pe primul loc",
    safetyText1: "Confortul și siguranța dumneavoastră sunt prioritățile noastre principale.",
    safetyText2: "Toate vehiculele sunt întreținute, curățate și pregătite cu grijă în mod regulat înainte de fiecare călătorie.",
    safetyText3: "Lucrăm numai cu șoferi profesioniști de încredere și parteneri de transport de înaltă calitate.",
    categories: {
      buses: "Autobuze VIP",
      minibuses: "Microbuze de lux",
      cars: "Mașini private și transferuri VIP",
      jeeps: "Jeep-uri 4x4 și transport în deșert",
      meetDrivers: "Faceți cunoștință cu șoferii noștri",
      videos: "Videoclipuri despre experiența de transport"
    },
    videoGalleryTitle: "Videoclipuri cu experiență VIP",
    ctaTitle: "Ești gata să explorezi Marocul confortabil?",
    ctaSubtitle: "Vorbește direct cu Allan – CEO și fondator",
    whatsapp: "WhatsApp: +972546338757",
    moroccoLine: "Linie directă Maroc: +212 6 63 63 05 79"
  },
  jewishHeritage: {
    pageTitle: "Tururi Kosher de lux în Maroc",
    pageSubtitle: "Patrimoniu evreiesc autentic, bucătărie 100% kosher, ospitalitate de lux și experiențe unice în Maroc.",
    introTitle: "Experiență de lux din patrimoniul evreiesc",
    introHeading: "Descoperiți Marocul evreiesc autentic",
    introText: "Descoperiți rădăcinile adânci ale istoriei evreiești din Maroc cu o experiență de călătorie elegantă, autentică și premium. Suntem specializați în a oferi o călătorie fără probleme pentru comunitățile evreiești din întreaga lume, concentrându-ne pe moștenire, conexiune și confort absolut.",
    introQuote: "„Maroc este un tărâm al toleranței și al conviețuirii, unde moștenirea evreiască este păstrată cu dragoste și respect”.",
    experiencesTitle: "Experiențele noastre Kosher includ",
    experiencesList: [
      "Mâncare și restaurante 100% cușer",
      "Bucătar privat Kosher disponibil",
      "Bucătărie tradițională evreiască marocană",
      "Hoteluri de lux de 4 și 5 stele",
      "Transport VIP privat",
      "Ghiduri profesionale multilingve",
      "Excursii în patrimoniul evreiesc și sinagogă",
      "Cimitire și muzee evreiești",
      "Experiențe în deșertul Sahara și hamam",
      "Asistență profesională 24/7"
    ],
    expFood: "Mancare 100% Kosher",
    expRestaurant: "Restaurant cușer",
    expChef: "Bucătar privat Kosher disponibil",
    expCuisine: "Bucătărie tradițională evreiască marocană",
    expHotels: "Hoteluri de lux 4 & 5 stele",
    expDeluxeHotels: "Hoteluri Deluxe disponibile la cerere",
    expTransport: "Transport VIP privat",
    expDrivers: "Șoferi profesioniști",
    expAC: "Vehicule cu aer condiționat",
    expWifi: "WiFi, TV și frigidere în vehicule selectate",
    expGuides: "Ghiduri profesionale multilingve",
    expStaff: "Personal vorbitor de ebraică / engleză / franceză / spaniolă / rusă / germană",
    expHeritage: "Tururi ale patrimoniului evreiesc",
    expSynagogues: "Sinagogi antice",
    expCemeteries: "Cimitire evreiești",
    expMuseums: "Muzeele evreiești",
    expSpiritual: "Experiențe spirituale și culturale",
    expDesert: "Experiențe în deșertul Sahara",
    expHammam: "Experiențe cu hamam marocan",
    expAttractions: "Atracții unice în Maroc",
    expAssistance: "Asistență 24/7",
    packagesTitle: "Pachete flexibile de călătorie Kosher",
    packagesIntro: "Personalizăm fiecare călătorie în funcție de nevoile, tradițiile, stilul de călătorie, datele și așteptările oaspeților noștri.",
    packageOptions: [
      "4-5 zile",
      "7-8 zile",
      "10-11 zile",
      "13-14 zile",
      "21 de zile",
      "Tururi private personalizate"
    ],
    package4_5: "4-5 zile",
    package7_8: "7-8 zile",
    package10_11: "10-11 zile",
    package13_14: "13-14 zile",
    package21: "21 de zile",
    packageTailor: "Tururi private personalizate",
    packagesQuote: "„Personalizam fiecare călătorie în funcție de nevoile, tradițiile, stilul de călătorie, datele și așteptările oaspeților noștri.”",
    safetyTitle: "Călătorie confortabilă, profesională și sigură",
    safetyText: "Tururile noastre funcționează cu o atenție deosebită adusă confortului, organizării, calității serviciilor și coordonării profesionale în Maroc.",
    safetyQuote: "„Tururile noastre funcționează cu o mare atenție acordată confortului, organizării, calității serviciilor și coordonării profesionale în Maroc.”",
    b2bTitle: "Parteneriate de călătorie B2B evreiești",
    b2bText: "Colaboram cu comunitățile evreiești, sinagogi, rabini și operatori de turism cușer din întreaga lume pentru a crea călătorii semnificative ale patrimoniului.",
    b2bPartnersList: "Lucrăm cu: comunități evreiești, sinagogi, rabini, organizații evreiești, touroperatori Kosher și agenții de turism din întreaga lume.",
    partnerBtn: "Colaborați cu noi",
    galleryTitle: "Galeria de experiență Kosher",
    videosTitle: "Videoclipuri recomandate",
    ctaTitle: "Ești gata să-ți începi călătoria?",
    msgAllan: "Trimite mesaj lui Allan pe WhatsApp",
    callMorocco: "Sunați Maroc: +212 6 63 63 05 79",
    ceoContact: "Vorbește cu Allan Hatchuel direct pe WhatsApp",
    exploreBtn: "Explorați Tururile Kosher"
  },
  aria: {
    selectLanguage: "Selectați limba",
    closeDetails: "Închide detalii",
    openMenu: "Deschide meniul",
    closeMenu: "Închide meniul",
    kosherTravel: "Kosher Travel Maroc",
    watchVideo: "Urmărește videoclipul Magic Morocco",
    followInstagram: "Urmărește-ne pe Instagram",
    followFacebook: "Urmărește-ne pe Facebook",
    ceoMessage: "CEO-ul Maroc te iubește",
    whatsappSocial: "WhatsApp",
    instagramSocial: "Instagram",
    facebookSocial: "Facebook",
    logoAlt: "Sigla MoroccoLovesYou",
    kingAlt: "Regele Marocului",
    kosherOptionsAlt: "Opțiuni Kosher",
    moroccoLandscape: "Peisajul Marocului",
    worldCupAlt: "Trofeu Cupei Mondiale cu steagul Marocului",
    b2bBannerAlt: "Banner pentru tur numai B2B - faceți clic pe WhatsApp",
    starAlt: "Steaua",
    playVideo: "Joacă",
    pauseVideo: "Pauză",
    vipBus: "Autobuz VIP",
    drivers: "Șoferii noștri",
    jewishHeritageArchitecture: "Arhitectura patrimoniului evreiesc",
    jewishHeritageMorocco: "Moștenirea evreiască Maroc",
    kosherFoodMorocco: "Mâncare Kosher Maroc",
    jewishHeritageExperience: "Experiența moștenirii evreiești",
    kosherMoroccanTable: "Masa marocana Kosher",
    luxuryHospitality: "Ospitalitate de lux",
    kosherExperience: "Experiență Kosher"
  },
  forms: {
    firstName: "de ex. Ioane",
    lastName: "de ex. Doe",
    email: "nume@example.com",
    subject: "Cum putem ajuta?",
    message: "Spune-ne mai multe despre planurile tale de călătorie...",
    phone: "Numărul dvs. de telefon",
    date: "Selectați o dată",
    guests: "Numărul de invitați"
  },
  common: {
    selectLanguage: "Selectați limba",
    instagram: "Instagram",
    facebook: "Facebook",
    loading: "Se încarcă...",
    error: "A apărut o eroare",
    success: "Succes!",
    noResults: "Nu s-au găsit rezultate",
    viewMore: "Vezi mai multe",
    viewLess: "Vedeți mai puțin",
    bookNow: "Rezervați acum",
    learnMore: "Aflați mai multe",
    contactUs: "Contactați-ne",
    close: "Închide",
    back: "Înapoi",
    next: "În continuare",
    previous: "Anterior",
    search: "Cauta...",
    filter: "Filtru",
    sort: "Sortează",
    price: "Preț",
    duration: "Durata",
    languages: {
      english: "engleză",
      american: "american",
      australia: "Australia",
      canada: "Canada",
      french: "francez",
      spanish: "spaniolă",
      hebrew: "ebraică",
      arabic: "العربية",
      german: "germană",
      italian: "italiană",
      japanese: "japoneză",
      chinese: "chineză",
      korean: "coreeană",
      vietnamese: "vietnamez",
      russian: "rusă",
      en: "engleză",
      "en-US": "american",
      "en-AU": "Australia",
      "en-CA": "Canada",
      fr: "francez",
      es: "spaniolă",
      he: "ebraică",
      ar: "العربية",
      de: "germană",
      it: "italiană",
      ja: "japoneză",
      zh: "chineză",
      ko: "coreeană",
      vi: "vietnamez",
      ru: "rusă",
      ro: "Română"
    }
  },
  whatsapp: {
    greeting: "Salut Maroc te iubește! 🌟",
    bookPackage: "Aș dori să rezerv următorul pachet:",
    packageInfo: "📦 Pachet: ",
    duration: "⏱️ Durata: ",
    price: "💰 Preț: ",
    bookingRequest: "Vă rog să-mi spuneți disponibilitatea și pașii următori. Multumesc!",
    cityTrip: "Aș dori să planific o excursie în {city}. Mă puteți ajuta?",
    silverPackage: "Sunt interesat de pachetul Silver World Cup",
    goldPackage: "Sunt interesat de pachetul Gold Cupa Mondială",
    diamondPackage: "Sunt interesat de pachetul VIP Diamond Cup",
    worldCupSecure: "Bună, vreau să-mi asigur locul pentru Maroc 2030.",
    kosherInquiry: "Sunt interesat de pachetele dvs. de călătorie Kosher Maroc.",
    customPackage: "Aș dori să creez un pachet personalizat pentru grupul nostru.",
    businessInquiry: "Sunt interesat de serviciile VIP Business Travel."
  },
  blog_posts: {
    post1: {
      title: "10 pietre prețioase ascunse de descoperit în Maroc",
      author: "Fatima Hassan",
      date: "15 martie 2024",
      category: "Ghid de călătorie",
      excerpt: "Descoperiți destinațiile mai puțin cunoscute și comorile ascunse ale Marocului pe care majoritatea turiștilor le dor. De la sate secrete de munte la zone de coastă curate, explorați Marocul autentic.",
      content: "Marocul este mult mai mult decât doar Marrakech și Casablanca. Acest ghid cuprinzător dezvăluie pietre prețioase ascunse..."
    },
    post2: {
      title: "Cel mai bun moment pentru a vizita Marocul: un ghid complet",
      author: "Ahmed Bennani",
      date: "10 martie 2024",
      category: "Planificarea",
      excerpt: "Îți plănuiești călătoria în Maroc? Aflați despre cele mai bune anotimpuri de vizitat, la ce să vă așteptați din punct de vedere meteorologic și cum să profitați la maximum de călătoria dvs. pe tot parcursul anului.",
      content: "Alegerea momentului potrivit pentru a vizita Marocul poate avea un impact semnificativ asupra experienței dvs. de călătorie. Iată ghidul nostru complet..."
    },
    post3: {
      title: "Bucătăria marocană: o aventură culinară",
      author: "Layla Rahim",
      date: "5 martie 2024",
      category: "Mâncare și cultură",
      excerpt: "Porniți într-o călătorie culinară prin Maroc. Descoperiți aromele bogate, rețetele tradiționale și experiențele culinare care fac mâncarea marocană renumită în lume.",
      content: "Bucătăria marocană este un amestec de influențe arabe, berbere, andaluze și africane. Fiecare fel de mâncare spune o poveste a moștenirii diverse a Marocului..."
    },
    post4: {
      title: "Cum să negociezi pe piețele marocane ca un profesionist",
      author: "Youssef Alaoui",
      date: "28 februarie 2024",
      category: "Sfaturi de călătorie",
      excerpt: "Stăpânește arta tocmeiului în soukurile și piețele marocane. Aflați eticheta culturală, tacticile de negociere și sfaturi din interior pentru a obține cele mai bune oferte.",
      content: "Tocmeala nu este doar o tranzacție pe piețele marocane; este un schimb cultural. Iată cum să o faci cu respect și eficient..."
    },
    post5: {
      title: "Trekking în Munții Atlas: Ce trebuie să știți",
      author: "Ahmed Bennani",
      date: "20 februarie 2024",
      category: "Aventura",
      excerpt: "Explorați maiestuoșii Munți Atlas pe jos. Obțineți sfaturi de specialitate cu privire la traseele de drumeție, ce să împachetați, considerații legate de altitudine și cel mai bun moment pentru aventura dvs. montană.",
      content: "Munții Atlas oferă unele dintre cele mai uluitoare peisaje din Africa de Nord. Fie că ești un drumeț experimentat sau un începător..."
    },
    post6: {
      title: "Safari în deșert: o experiență de neuitat",
      author: "Fatima Hassan",
      date: "15 februarie 2024",
      category: "Aventura",
      excerpt: "Experimentați magia deșertului Sahara din Maroc. Trekking cu cămile, nopți înstelate sub corturi de pânză și momente de răsărit pe care nu le vei uita niciodată.",
      content: "Deșertul Sahara reprezintă sufletul Marocului. Un safari în deșert este mai mult decât o simplă aventură; este o călătorie spirituală..."
    },
    post7: {
      title: "Eticheta culturală: Respectarea tradițiilor marocane",
      author: "Layla Rahim",
      date: "10 februarie 2024",
      category: "Cultură",
      excerpt: "Aflați normele culturale esențiale, obiceiurile și eticheta pentru a vă implica respectuos cu oamenii și tradițiile marocane în timpul vizitei dumneavoastră.",
      content: "Înțelegerea și respectarea obiceiurilor locale este crucială atunci când călătoriți în Maroc. Acest ghid acoperă practici culturale esențiale..."
    },
    post8: {
      title: "Fotografie în Maroc: Capturing the Magic",
      author: "Youssef Alaoui",
      date: "5 februarie 2024",
      category: "Fotografie",
      excerpt: "Descoperiți cele mai fotogenice locații din Maroc și sfaturi profesionale pentru a surprinde imagini uimitoare cu peisaje, oameni și cultură.",
      content: "Marocul este paradisul fotografilor. De la medina albastră până la deșerturile aurii, fiecare colț oferă oportunități incredibile de fotografiere..."
    }
  },
  jobs: {
    title: "Cariere și Oportunități",
    intro: "Alătură-te echipei MoroccoLovesYou și construiește-ți viitorul în călătoriile de lux",
    workWith: "Lucrați cu dragoste, grijă și excelență",
    introText: "Căutăm persoane pasionate, dedicate, care împărtășesc viziunea noastră de a oferi experiențe de călătorie de clasă mondială. Alăturați-vă echipei noastre în creștere și fiți parte din ceva special.",
    openPositions: "Poziții deschise",
    requirements: "Cerințe:",
    readyJoin: "Sunteți gata să ni se alăture?",
    sendCV: "Trimiteți CV-ul la careers@moroccolovesyou.com",
    instructions: "Includeți o scurtă scrisoare de intenție care să explice de ce doriți să vă alăturați echipei Morocco Loves You.",
    emailCv: "Trimiteți CV-ul către CEO",
    chatCeo: "Discutați cu CEO-ul pe WhatsApp",
    job1: {
      title: "Ghid turistic profesional multilingv",
      type: "Full-time / Sezonier",
      location: "Marrakech / Fes / în întregul Maroc",
      description: "Căutăm ghizi pasionați, cunoscători și povestitori care pot aduce Marocul la viață pentru oaspeții noștri VIP. Rolul dumneavoastră implică conducerea tururilor premium, împărtășirea cunoștințelor culturale și asigurarea satisfacției oaspeților.",
      req1: "Vorbește fluent cel puțin 2 limbi (de preferință franceză, spaniolă, engleză, ebraică, germană, rusă sau italiană)",
      req2: "Cunoaștere profundă a istoriei, culturii și geografiei marocane",
      req3: "Abilități profesionale, amabile și excelente în serviciul clienți",
      req4: "Fitness pentru drumeții în deșert și activități în aer liber"
    },
    job2: {
      title: "Sofer executiv VIP",
      type: "Full-Time",
      location: "La tot Marocul",
      description: "Alăturați-vă echipei noastre de transport de lux care conduce vehicule Mercedes moderne de ultimă generație. Veți oferi transferuri VIP, veți asigura confortul și siguranța oaspeților și veți reprezenta marca noastră cu profesionalism și ospitalitate.",
      req1: "Permis de conducere valabil cu un dosar excelent de conducere (de preferință peste 10 ani de experiență)",
      req2: "Fluență în limba engleză (limbi suplimentare sunt un plus)",
      req3: "Aspect profesional și comportament politicos",
      req4: "Cunoașterea drumurilor și rutelor Marocului; GPS/experienta de navigare"
    },
    job3: {
      title: "Coordonator experiență clienți",
      type: "Full-Time",
      location: "Telecomandă/Hibrid (Biroul Fes)",
      description: "Sprijiniți biroul nostru CEO în organizarea de itinerarii personalizate de lux, gestionarea comunicării cu oaspeții și asigurarea unei coordonări perfecte a călătoriilor. Acest rol este ideal pentru profesioniști organizați, orientați spre detalii.",
      req1: "Excelente abilități de organizare și comunicare",
      req2: "Experiență în călătorii, ospitalitate sau servicii pentru clienți",
      req3: "Fluent în limba engleză; limbi suplimentare un bonus",
      req4: "Cunoștințe cu sistemele de rezervare și Microsoft Office Suite"
    }
  },
  gallery_categories: {
    food: "Experiență culinară",
    destinations: "Destinații",
    kosher: "Kosher",
    transport: "Transport VIP"
  }
};

export default ro;
